import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sum',
  standalone: false
})
export class SumPipe<T> implements PipeTransform {
  public transform(items: Array<T>, attr: keyof T): number {
    return items?.reduce<number>(
      (a, b) => a + coerceNumberProperty(b[attr]),
      0
    );
  }
}
